import { render, staticRenderFns } from "./FragmentRecipe.vue?vue&type=template&id=2d0c7a17&scoped=true"
import script from "./FragmentRecipe.vue?vue&type=script&lang=ts"
export * from "./FragmentRecipe.vue?vue&type=script&lang=ts"
import style0 from "./FragmentRecipe.vue?vue&type=style&index=0&id=2d0c7a17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c7a17",
  null
  
)

export default component.exports